(() => {
  if (window.__shrineCartDrawerFixLoaded) return;
  window.__shrineCartDrawerFixLoaded = true;

  const ADD_TO_CART_FORM = 'form[action*="/cart/add"]';

  document.addEventListener(
    'submit',
    async function (event) {
      const form = event.target.closest?.(ADD_TO_CART_FORM);

      if (!form) return;
      if (form.dataset.cartDrawerIgnore === 'true') return;

      const cartDrawer = document.querySelector('cart-drawer');

      /*
       * Không có cart drawer thì giữ nguyên chức năng mặc định.
       */
      if (!cartDrawer) {
        console.warn(
          '[Shrine Cart Fix] Không tìm thấy <cart-drawer>. Kiểm tra Cart type trong Theme settings.'
        );
        return;
      }

      /*
       * Ngăn Shrine chạy handler cũ và chuyển sang trang /cart.
       */
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();

      if (form.dataset.cartDrawerLoading === 'true') return;

      if (!form.checkValidity()) {
        form.reportValidity();
        return;
      }

      const submitButton =
        event.submitter || form.querySelector('[type="submit"]');

      form.dataset.cartDrawerLoading = 'true';

      if (submitButton) {
        submitButton.disabled = true;
        submitButton.setAttribute('aria-disabled', 'true');
        submitButton.classList.add('loading');
      }

      try {
        let sections = ['cart-drawer', 'cart-icon-bubble'];

        /*
         * Lấy đúng danh sách section mà Shrine Pro yêu cầu.
         */
        if (typeof cartDrawer.getSectionsToRender === 'function') {
          const shrineSections = cartDrawer
            .getSectionsToRender()
            .map((section) => section.section || section.id)
            .filter(Boolean);

          if (shrineSections.length) {
            sections = shrineSections;
          }
        }

        sections = [...new Set(sections)];

        const formData = new FormData(form);

        /*
         * Shopify trả về HTML mới của drawer và cart icon
         * cùng response add-to-cart.
         */
        formData.set('sections', sections.join(','));
        formData.set(
          'sections_url',
          window.location.pathname + window.location.search
        );

        const shopifyRoot = window.Shopify?.routes?.root || '/';

        const response = await fetch(
          `${shopifyRoot}cart/add.js`,
          {
            method: 'POST',
            headers: {
              Accept: 'application/json',
              'X-Requested-With': 'XMLHttpRequest'
            },
            body: formData
          }
        );

        const result = await response.json();

        if (!response.ok) {
          throw new Error(
            result.description ||
              result.message ||
              'Không thể thêm sản phẩm vào giỏ hàng.'
          );
        }

        cartDrawer.classList.remove('is-empty');

        /*
         * Cập nhật toàn bộ nội dung drawer bằng hàm native của Shrine.
         */
        if (
          result.sections &&
          typeof cartDrawer.renderContents === 'function'
        ) {
          cartDrawer.renderContents(result);
        } else {
          await refreshCartDrawer(cartDrawer);
        }

        /*
         * Một số bản Shrine tự mở drawer trong renderContents,
         * nhưng gọi thêm open() để bảo đảm drawer được mở.
         */
        window.setTimeout(() => {
          const updatedDrawer =
            document.querySelector('cart-drawer');

          if (
            updatedDrawer &&
            typeof updatedDrawer.open === 'function'
          ) {
            updatedDrawer.open();
          } else if (updatedDrawer) {
            updatedDrawer.classList.add('active');
            updatedDrawer.setAttribute('open', '');
          }
        }, 100);

        document.dispatchEvent(
          new CustomEvent('cart:updated', {
            detail: {
              source: 'shrine-custom-cart-fix',
              cart: result
            }
          })
        );
      } catch (error) {
        console.error('[Shrine Cart Drawer Fix]', error);

        alert(
          error.message ||
            'Có lỗi xảy ra khi thêm sản phẩm vào giỏ hàng.'
        );
      } finally {
        form.dataset.cartDrawerLoading = 'false';

        if (submitButton) {
          submitButton.disabled = false;
          submitButton.removeAttribute('aria-disabled');
          submitButton.classList.remove('loading');
        }
      }
    },
    true
  );

  async function refreshCartDrawer(cartDrawer) {
    const shopifyRoot = window.Shopify?.routes?.root || '/';

    const response = await fetch(
      `${shopifyRoot}cart?sections=cart-drawer,cart-icon-bubble`,
      {
        headers: {
          Accept: 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        }
      }
    );

    if (!response.ok) {
      throw new Error('Không thể cập nhật Cart Drawer.');
    }

    const sections = await response.json();
    const parser = new DOMParser();

    if (sections['cart-drawer']) {
      const parsedDrawer = parser.parseFromString(
        sections['cart-drawer'],
        'text/html'
      );

      const newDrawer =
        parsedDrawer.querySelector('cart-drawer');

      if (newDrawer) {
        cartDrawer.innerHTML = newDrawer.innerHTML;
      } else {
        const newDrawerInner =
          parsedDrawer.querySelector('.drawer__inner');

        const currentDrawerInner =
          cartDrawer.querySelector('.drawer__inner');

        if (newDrawerInner && currentDrawerInner) {
          currentDrawerInner.innerHTML =
            newDrawerInner.innerHTML;
        }
      }
    }

    if (sections['cart-icon-bubble']) {
      const parsedBubble = parser.parseFromString(
        sections['cart-icon-bubble'],
        'text/html'
      );

      const currentBubble =
        document.getElementById('cart-icon-bubble');

      const newBubble =
        parsedBubble.getElementById('cart-icon-bubble');

      if (currentBubble && newBubble) {
        currentBubble.innerHTML = newBubble.innerHTML;
      }
    }
  }


  /*
   * Fix #2: bam vao icon gio hang tren header cung phai mo Cart Drawer
   * thay vi chuyen sang trang /cart.
   */
  function initCartIconDrawerOpener() {
    const cartIconLink = document.querySelector('.header__icon--cart');
    const cartDrawer = document.querySelector('cart-drawer');

    if (!cartIconLink || !cartDrawer) return;
    if (cartIconLink.dataset.cartDrawerIconBound === 'true') return;
    cartIconLink.dataset.cartDrawerIconBound = 'true';

    cartIconLink.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();

      if (typeof cartDrawer.open === 'function') {
        cartDrawer.open();
      } else {
        cartDrawer.classList.remove('is-empty');
        cartDrawer.classList.add('active');
        cartDrawer.setAttribute('open', '');
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCartIconDrawerOpener);
  } else {
    initCartIconDrawerOpener();
  }
})();